<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="grey-div">
      <!-- 企业 -->
      <div class="each-tab"
           @click="activeKey=item.tabKey"
           :class="item.tabKey==activeKey?'active':''"
           v-for="item in tabList"
           :key="item.tabKey">
        <svg aria-hidden="true"
             class="icon-svg icon">
          <use xlink:href="#icon-shop"></use>
        </svg>
        <div class="text">
          {{item.name}}
        </div>
      </div>
      <!-- 政府/事业单位 -->
      <!-- 个体工商户 -->
      <!-- 其他 -->
    </div>
    <transition name="el-zoom-in-top">
      <enterprise v-show="activeKey=='10'"
                  ref="enterprise"
                  @submitHandle="submitHandle"
                  :companyName="companyName"
                  :industryList="industryList"></enterprise>
    </transition>
    <transition name="el-zoom-in-top">
      <government v-show="activeKey=='20'"
                  ref="government"
                  :companyName="companyName"
                  @submitHandle="submitHandle"></government>
    </transition>
    <transition name="el-zoom-in-top">
      <personal v-show="activeKey=='30'"
                ref="personal"
                :companyName="companyName"
                @submitHandle="submitHandle"
                :industryList="industryList"></personal>
    </transition>
    <transition name="el-zoom-in-top">
      <other v-show="activeKey=='90'"
             ref="other"
             :companyName="companyName"
             @submitHandle="submitHandle"
             :industryList="industryList"></other>
    </transition>
    <div class="submit-div">
      <!-- <div>
        <el-checkbox v-model="checked">
          &nbsp;&nbsp;阅读并同意认证 <span class="font-color-all">《认证协议》&nbsp;&nbsp;《服务协议》</span>
        </el-checkbox>
      </div> -->
      <div>
        <el-button type="primary"
                   @click="dataFormSubmitHandle()"
                   class="w-percent-100 top-20">认证</el-button>
      </div>
    </div>
  </el-card>
</template>
<script>
import Enterprise from './enterprise'
import Government from './government'
import Personal from './personal'
import Other from './other'
export default {
  data () {
    return {
      tabList: [
        {
          name: '企业',
          tabKey: '10'
        },
        {
          name: '政府/事业单位',
          tabKey: '20'
        },
        {
          name: '个体工商户',
          tabKey: '30'
        },
        {
          name: '其他',
          tabKey: '90'
        }
      ],
      activeKey: '10',
      checked: true,
      industryList: [],
      companyId: '',
      companyName: ''
    }
  },
  components: {
    Enterprise,
    Government,
    Personal,
    Other
  },
  created () { },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.$nextTick(() => {
        if (!this.$store.state.user.companyAccountInfo || !this.$store.state.user.companyAccountInfo.length) {
          this.$router.replace({
            name: 'basicInfo'
          })
        }
      })
      let company = null
      if (this.$route.query && this.$route.query.cId) {
        company = this.$store.state.user.companyAccountInfo.find(item => {
          return item.companyId === this.$route.query.cId
        })
      } else {
        company = this.$store.state.user.companyAccountInfo.find(item => {
          return item.authentFlag !== '40' && item.authentFlag !== '20'
        })
      }
      if (company) {
        this.companyId = company.companyId
        this.companyName = company.companyName
      }
      this.getIndustryList()
    },
    dataFormSubmitHandle () {
      let refName = ''
      if (this.activeKey === '10') {
        refName = 'enterprise'
      } else if (this.activeKey === '20') {
        refName = 'government'
      } else if (this.activeKey === '30') {
        refName = 'personal'
      } else if (this.activeKey === '40') {
        refName = 'other'
      }
      if (refName) {
        this.$nextTick(() => {
          this.$refs[refName].fomatDataForm()
        })
      }
    },
    submitHandle () {
      if (!this.checked) {
        return this.$message.warning('请阅读，同意相关 协议 ')
      }
      var form = {}
      let content = ''
      if (this.activeKey === '10') {
        form = { ...this.$refs.enterprise.dataForm }
        if (!form.fileList.find(item => {
          return item.type === 20
        })) {
          content += '[营业执照]'
        }
        if (!form.fileList.find(item => {
          return item.type === 301
        })) {
          content += '[身份证正面]'
        }
        if (!form.fileList.find(item => {
          return item.type === 302
        })) {
          content += '[身份证反面]'
        }
      }
      if (this.activeKey === '20') {
        form = { ...this.$refs.government.dataForm }
        if (!form.fileList.find(item => {
          return item.type === 40
        })) {
          content += '[事业单位法人证书/统一社会信用代码证书图片]'
        }
      }
      if (this.activeKey === '30') {
        form = { ...this.$refs.personal.dataForm }
        if (!form.fileList.find(item => {
          return item.type === 20
        })) {
          content += '[营业执照]'
        }
        if (!form.fileList.find(item => {
          return item.type === 301
        })) {
          content += '[身份证正面]'
        }
        if (!form.fileList.find(item => {
          return item.type === 302
        })) {
          content += '[身份证反面]'
        }
      }
      if (this.activeKey === '40') {
        form = { ...this.$refs.other.dataForm }
        if (!form.fileList.find(item => {
          return item.type === 40
        })) {
          content += '[事业单位法人证书/统一社会信用代码证书图片]'
        }
      }
      if (content) {
        this.$confirm(`您提交的认证申请未上传${content}，上传后可以更快完成认证验证。您确定跳过吗？`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '返回上传',
          type: 'warning'
        }).then(() => {
          this.submit()
        }).catch(() => {
        })
      } else {
        this.submit()
      }
    },
    submit () {
      var form = {}
      if (this.activeKey === '10') {
        form = { ...this.$refs.enterprise.dataForm }
      }
      if (this.activeKey === '20') {
        form = { ...this.$refs.government.dataForm }
      }
      if (this.activeKey === '30') {
        form = { ...this.$refs.personal.dataForm }
      }
      if (this.activeKey === '40') {
        form = { ...this.$refs.other.dataForm }
      }
      this.$http.post(`/front/user/sys/custCompany/submitCertification`, {
        ...form,
        industry: form.industry.length ? [form.industry] : [],
        companyId: this.companyId
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              // this.bus.$emit('refushUserInfo')
              this.$router.go(-1)
              // ---最好刷新页面
              setTimeout(() => {
                window.location.reload()
              }, 1000)
            }
          })
        }).catch(() => {})
    },
    // 获取行业列表
    getIndustryList () {
      this.industryList = []
      this.$http.post('/help/user/sys/custIndustry/queryList', {}).then(({ data: res }) => {
        this.industryList = res.data
      }).catch(() => { })
    }
  }
}
</script>
<style lang='scss' scoped>
.each-tab {
  color: #999999;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 40px;
  .icon {
    font-size: 30px;
    color: #999999;
  }
  .text {
    font-size: 14px;
    padding: 0 10px;
    text-align: center;
    color: #999999;
  }
}
.each-tab.active {
  border-bottom: 2px solid rgba(72, 177, 222, 1);
  color: #48b1de;
}
.submit-div {
  width: 40%;
  margin: 0 190px;
}
</style>
